import objectPath from 'object-path'
import { store } from '@/_store'

let roles = {
  '0': 'user',
  '1': 'doctor'
}

let permissions = {
  user: {
    own: {
      test: ['view'],
      annotation: ['view-own']
    },
    shared: {
      // could be: ['users', 'bp', 'ecg', 'bp-stats', 'bp-overall', 'arithmies'],
      test: ['users', 'ecg', 'arithmies'],
      annotation: []
    }
  },
  doctor: {
    own: {
      test: ['view'],
      annotation: ['view-own']
    },
    shared: {
      // could be: ['users', 'bp', 'ecg', 'bp-stats', 'bp-overall', 'arithmies'],
      test: ['users', 'ecg', 'arithmies'],
      annotation: ['create', 'delete'] // dont add update here!
    }
  }
}

export function can (cat, key) {
  let path = `${roles[store.getters['account/userRole'].toString()]}.${cat}`
  return store.getters['account/isTokenActive'] && objectPath.has(permissions, path) && objectPath.get(permissions, path).includes(key)
}

export const rbacMixin = {
  methods: {
    can: (cat, key) => {
      return can(cat, key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/rbac.js